var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Button, Checkbox, Flex, Icon, Input, Menu, MenuButton, MenuItem, MenuList, SimpleGrid, Text } from '@chakra-ui/react';
import { makeObservable, observable, action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { ChromePicker, SketchPicker } from 'react-color';
import { MdFormatAlignLeft } from '@react-icons/all-files/md/MdFormatAlignLeft';
import { MdFormatColorFill } from '@react-icons/all-files/md/MdFormatColorFill';
import { MdBorderColor } from '@react-icons/all-files/md/MdBorderColor';
import { MdFormatColorText } from '@react-icons/all-files/md/MdFormatColorText';
import { MdFormatAlignRight } from '@react-icons/all-files/md/MdFormatAlignRight';
import { MdFormatAlignJustify } from '@react-icons/all-files/md/MdFormatAlignJustify';
export class DiagramPropertyPaneState {
    constructor() {
        this.color = "";
        this.bordercolor = "black";
        this.textcolor = "black";
        this.onok = undefined;
        this.oncancel = undefined;
        this.showtextproperty = true;
        this.boldtext = false;
        this.italictext = false;
        this.underline = false;
        this.showcolorpicker = false;
        this.showtextcolorpicker = false;
        this.showbordercolorpicker = false;
        this.fontsize = 12;
        this.showfontmenu = false;
        this.textalign = 'Center';
        makeObservable(this);
    }
    setShowTextProperty(show) {
        this.showtextproperty = show;
    }
    setShowFontMenu(show) {
        this.showfontmenu = show;
    }
    setShowColorPicker(show) {
        this.showcolorpicker = show;
    }
    setShowTextColorPicker(show) {
        this.showtextcolorpicker = show;
    }
    setShowBorderColorPicker(show) {
        this.showbordercolorpicker = show;
    }
    setbold(show) {
        this.boldtext = show;
    }
    setDefaultTextProperty() {
        this.setbold(false);
        this.setItalic(false);
        this.setTextColor("black");
        this.setFontSize(12);
        this.setTextAlign("Center");
        this.setBorderColor("black");
        this.setShowBorderColorPicker(false);
        this.setShowColorPicker(false);
        this.setShowTextColorPicker(false);
    }
    setItalic(show) {
        this.italictext = show;
    }
    setTextColor(color) {
        this.textcolor = color;
    }
    setBorderColor(color) {
        this.bordercolor = color;
    }
    setColor(color) {
        this.color = color;
    }
    setFontSize(size) {
        this.fontsize = size;
    }
    setTextAlign(align) {
        this.textalign = align;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "color", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "bordercolor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "textcolor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "showtextproperty", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "boldtext", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "italictext", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "underline", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "showcolorpicker", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "showtextcolorpicker", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "showbordercolorpicker", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "fontsize", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DiagramPropertyPaneState.prototype, "showfontmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], DiagramPropertyPaneState.prototype, "textalign", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setShowTextProperty", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setShowFontMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setShowColorPicker", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setShowTextColorPicker", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setShowBorderColorPicker", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setbold", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setItalic", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setTextColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setBorderColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setFontSize", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DiagramPropertyPaneState.prototype, "setTextAlign", null);
let DiagramPrpertyPane = class DiagramPrpertyPane extends React.Component {
    constructor(prop) {
        super(prop);
    }
    setFont(size) {
        this.props.state.setFontSize(size);
    }
    setFontInput(size) {
        this.props.state.setFontSize(parseInt(size));
    }
    isWhiteColor(color) {
        const c = color.toLowerCase();
        return c === 'white' || c === '#fff' || c === '#ffffff';
    }
    render() {
        return React.createElement(Box, { ml: '5px', h: '100%' },
            React.createElement(Flex, { align: 'center', h: '70px', borderBottomColor: 'lightgray', borderBottomWidth: '1px' },
                React.createElement(Text, { fontWeight: 'bold', fontSize: '18px' }, "Property")),
            React.createElement(Box, { mt: '20px', h: '80%', maxH: '80%', overflow: 'auto' },
                React.createElement(SimpleGrid, { columns: 3 },
                    React.createElement(Box, null,
                        React.createElement(Text, { ml: '2px', fontSize: 12, alignSelf: 'center' }, "Fill Color")),
                    React.createElement(Box, null,
                        React.createElement(Icon, { as: MdFormatColorFill, h: '30px', w: '30px', _hover: { cursor: 'pointer' }, onClick: () => this.props.state.setShowColorPicker(!this.props.state.showcolorpicker), color: this.props.state.color, background: this.isWhiteColor(this.props.state.color) ? '#404040' : '' }))),
                this.props.state.showcolorpicker && React.createElement(SimpleGrid, { columns: 1 },
                    React.createElement(Box, null,
                        React.createElement(ChromePicker, { color: this.props.state.color, onChange: ({ hex }) => this.props.state.setColor(hex) }),
                        " ")),
                React.createElement(SimpleGrid, { mt: '20px', columns: 3 },
                    React.createElement(Box, null,
                        React.createElement(Text, { ml: '2px', fontSize: 12, alignSelf: 'center' }, "Border Color")),
                    React.createElement(Box, null,
                        React.createElement(Box, null,
                            React.createElement(Icon, { as: MdBorderColor, h: '30px', w: '30px', _hover: { cursor: 'pointer' }, color: this.props.state.bordercolor, background: this.isWhiteColor(this.props.state.bordercolor) ? '#404040' : '', onClick: () => this.props.state.setShowBorderColorPicker(!this.props.state.showbordercolorpicker) })))),
                this.props.state.showbordercolorpicker && React.createElement(SimpleGrid, { columns: 1 },
                    React.createElement(Box, null,
                        React.createElement(ChromePicker, { color: this.props.state.bordercolor, onChange: ({ hex }) => this.props.state.setBorderColor(hex) }),
                        " ")),
                this.props.state.showtextproperty && React.createElement(SimpleGrid, { mt: '20px', columns: 3 },
                    React.createElement(Flex, null,
                        React.createElement(Text, { ml: '2px', fontSize: 12, alignSelf: 'center' }, "Text Color")),
                    React.createElement(Box, null,
                        React.createElement(Box, null,
                            React.createElement(Icon, { as: MdFormatColorText, h: '30px', w: '30px', _hover: { cursor: 'pointer' }, color: this.props.state.textcolor, background: this.isWhiteColor(this.props.state.textcolor) ? '#404040' : '', onClick: () => this.props.state.setShowTextColorPicker(!this.props.state.showtextcolorpicker) })))),
                this.props.state.showtextcolorpicker && React.createElement(SimpleGrid, { columns: 1 },
                    React.createElement(Box, null,
                        React.createElement(ChromePicker, { color: this.props.state.textcolor, onChange: ({ hex }) => this.props.state.setTextColor(hex) }),
                        " ")),
                this.props.state.showtextproperty && React.createElement(SimpleGrid, { mt: '20px', columns: 3, spacing: 5 },
                    React.createElement(Box, null,
                        React.createElement(Checkbox, { onChange: (e) => this.props.state.setbold(e.currentTarget.checked), defaultChecked: this.props.state.boldtext, fontSize: 12 }, "Bold")),
                    React.createElement(Box, null,
                        React.createElement(Checkbox, { onChange: (e) => this.props.state.setItalic(e.currentTarget.checked), ml: '10px', defaultChecked: this.props.state.italictext, fontSize: 12 }, "Italic"))),
                this.props.state.showtextproperty && React.createElement(SimpleGrid, { mt: '20px', columns: 3, spacing: 5 },
                    React.createElement(Box, null,
                        React.createElement(Menu, { isLazy: true, isOpen: this.props.state.showfontmenu, closeOnSelect: true, onClose: () => this.props.state.setShowFontMenu(false) },
                            React.createElement(MenuButton, { onClick: () => this.props.state.setShowFontMenu(!this.props.state.showfontmenu), as: Button, style: { width: 100, marginLeft: '5px' } }, "Font Size"),
                            this.props.state.showfontmenu && React.createElement(MenuList, { maxH: "100px", overflowY: 'auto' },
                                React.createElement(MenuItem, { onClick: () => this.setFont(10) }, "10"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(12) }, "12"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(14) }, "14"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(16) }, "16"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(19) }, "18"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(20) }, "20"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(22) }, "22"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(24) }, "24"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(26) }, "26"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(28) }, "28"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(32) }, "32"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(36) }, "36"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(40) }, "40"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(44) }, "44"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(48) }, "48"),
                                React.createElement(MenuItem, { onClick: () => this.setFont(52) }, "52")))),
                    React.createElement(Box, { ml: '10px', alignSelf: 'center', textAlign: 'center' },
                        React.createElement(Input, { ml: 2, width: '80px', onChange: (e) => this.setFontInput(e.currentTarget.value), value: this.props.state.fontsize > 0 ? this.props.state.fontsize + "" : '' }))),
                React.createElement(SimpleGrid, { columns: 1, mt: 10 },
                    React.createElement(Box, null,
                        React.createElement(Text, null, "Alignment"))),
                this.props.state.showtextproperty && React.createElement(SimpleGrid, { mt: '20px', columns: 3, spacing: 5 },
                    React.createElement(Box, null,
                        React.createElement(Icon, { bg: this.props.state.textalign === 'Left' ? 'lightgray' : '', as: MdFormatAlignLeft, _hover: { cursor: 'pointer' }, onClick: () => this.props.state.setTextAlign('Left') })),
                    React.createElement(Box, null,
                        React.createElement(Icon, { bg: this.props.state.textalign === 'Center' ? 'lightgray' : '', as: MdFormatAlignJustify, _hover: { cursor: 'pointer' }, onClick: () => this.props.state.setTextAlign('Center') })),
                    React.createElement(Box, null,
                        React.createElement(Icon, { bg: this.props.state.textalign === 'Right' ? 'lightgray' : '', as: MdFormatAlignRight, _hover: { cursor: 'pointer' }, onClick: () => this.props.state.setTextAlign('Right') })))),
            React.createElement(Flex, { mt: '5px' },
                React.createElement(Button, { onClick: () => { var _a, _b; return (_b = (_a = this.props.state).onok) === null || _b === void 0 ? void 0 : _b.call(_a); }, bg: 'green' }, "Apply"),
                React.createElement(Button, { onClick: () => { var _a, _b; return (_b = (_a = this.props.state).oncancel) === null || _b === void 0 ? void 0 : _b.call(_a); }, ml: '20px', bg: 'red' }, "Close")));
    }
    render_old() {
        return React.createElement(Box, { h: '100%' },
            React.createElement(Box, { h: '80%', maxH: '80%', overflow: 'auto' },
                React.createElement(Flex, { mt: '10px' },
                    React.createElement(Text, { fontWeight: 'bold' }, "Color: "),
                    React.createElement(Box, null,
                        React.createElement(Box, { _hover: { cursor: 'pointer' }, onClick: () => this.props.state.setShowColorPicker(!this.props.state.showcolorpicker), style: {
                                width: 20, height: 20, borderColor: 'black',
                                borderWidth: 1,
                                borderRadius: 1, backgroundColor: this.props.state.color
                            } }),
                        React.createElement(Box, { mt: '10px' }, this.props.state.showcolorpicker &&
                            React.createElement(SketchPicker, { color: this.props.state.color, onChange: ({ hex }) => this.props.state.setColor(hex) })))),
                this.props.state.showtextproperty && React.createElement(Flex, { mt: '10px' },
                    React.createElement(Text, { fontWeight: 'bold' }, "Text Color: "),
                    React.createElement(Box, null,
                        React.createElement(Box, { _hover: { cursor: 'pointer' }, onClick: () => this.props.state.setShowTextColorPicker(!this.props.state.showtextcolorpicker), style: {
                                width: 20, height: 20, borderRadius: 1,
                                borderColor: 'black',
                                borderWidth: 10,
                                backgroundColor: this.props.state.textcolor
                            } }),
                        React.createElement(Box, { mt: '10px' }, true &&
                            React.createElement(SketchPicker, { color: this.props.state.textcolor, onChange: ({ hex }) => this.props.state.setTextColor(hex) })))),
                this.props.state.showtextproperty && React.createElement(Box, { ml: '30px', mt: '30px' },
                    React.createElement(Checkbox, { onChange: (e) => this.props.state.setbold(e.currentTarget.checked), defaultChecked: this.props.state.boldtext }, "Bold"),
                    React.createElement(Checkbox, { onChange: (e) => this.props.state.setItalic(e.currentTarget.checked), ml: '10px', defaultChecked: this.props.state.italictext }, "Italic"))),
            React.createElement(Flex, null,
                React.createElement(Button, { onClick: () => { var _a, _b; return (_b = (_a = this.props.state).onok) === null || _b === void 0 ? void 0 : _b.call(_a); }, bg: 'green' }, "Apply"),
                React.createElement(Button, { onClick: () => { var _a, _b; return (_b = (_a = this.props.state).oncancel) === null || _b === void 0 ? void 0 : _b.call(_a); }, ml: '20px', bg: 'red' }, "Close")));
    }
};
DiagramPrpertyPane = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DiagramPrpertyPane);
export { DiagramPrpertyPane };
